import * as GraphqlImporter from './graphql-importer'
import commonRequestApi from '../../request'
import Response from '../../Response'
import { DocumentNode } from 'graphql'

export const SERVER_URL = '/web/gql/PlatformBasicData'

// 枚举
export enum UserJobState {
  deleted = 'deleted',
  deletedAndUnscheduled = 'deletedAndUnscheduled',
  unstart = 'unstart',
  running = 'running',
  paused = 'paused',
  interrupted = 'interrupted',
  resumed = 'resumed',
  deletedFromScheduler = 'deletedFromScheduler',
  executed = 'executed',
  fail = 'fail',
  addedToScheduler = 'addedToScheduler',
  toExecuted = 'toExecuted',
  deleteAllRelevance = 'deleteAllRelevance',
  deleteSchedulerRelevance = 'deleteSchedulerRelevance',
  rescheduled = 'rescheduled',
  updated = 'updated',
  updatedAndRescheduled = 'updatedAndRescheduled'
}
export enum UnitTypeEnum {
  UNIT_TYPE_SUBPROJECT = 'UNIT_TYPE_SUBPROJECT',
  UNIT_TYPE_FINANCE = 'UNIT_TYPE_FINANCE',
  UNIT_TYPE_EDUCATIONAL = 'UNIT_TYPE_EDUCATIONAL',
  UNIT_TYPE_TEACH = 'UNIT_TYPE_TEACH',
  UNIT_TYPE_CUSTOMER = 'UNIT_TYPE_CUSTOMER',
  UNIT_TYPE_STUDENT = 'UNIT_TYPE_STUDENT'
}
export enum AsyncExecuteResultEnum {
  SUCCESS = 'SUCCESS',
  FAIL = 'FAIL',
  PART_SUCCESS = 'PART_SUCCESS',
  ERROR = 'ERROR'
}

// 类

export class Page {
  pageNo?: number
  pageSize?: number
}

export class AdministratorQueryDTO {
  /**
   * 查询单位id，默认本单位
   */
  unitIdList?: Array<string>
  /**
   * 用户名
   */
  loginInput?: string
  /**
   * 姓名
   */
  name?: string
  /**
   * 启用状态
   */
  status?: number
  /**
   * 所属角色id
   */
  roleIds?: Array<string>
}

/**
 * 客户查询用户信息用的查询条件
@author huanghj
 */
export class CustomerServiceStudentQueryDTO {
  orderNo?: string
  nameOrNickName?: string
  phoneNumber?: string
}

/**
 * 任务查询参数
@author: eleven
@date: 2020/4/14
 */
export class UserJobParamDTO {
  /**
   * 任务组名
   */
  group?: string
  /**
   * 任务当前的运行状态
   */
  userJobStateList?: Array<UserJobState>
  /**
   * 开始处理时间
   */
  startDate?: string
  /**
   * 处理完成时间
   */
  endDate?: string
}

/**
 * 运营域用户管理用的学员查询DTO
@author huanghj
 */
export class UserManageStudentQueryDTO {
  /**
   * 用户名或姓名
   */
  nameOrNickName?: string
  /**
   * 手机号
   */
  phoneNumber?: string
  /**
   * 注册所属培训机构id
   */
  registerUnitIdList?: Array<string>
  /**
   * 注册时间起
   */
  registerTimeStart?: string
  /**
   * 注册时间止
   */
  registerTimeEnd?: string
  /**
   * 所在地区路径
   */
  areaPath?: string
}

/**
 * 培训机构查询参数
 */
export class TeachUnitQueryDTO {
  /**
   * 单位名称
   */
  name?: string
  /**
   * 单位地区 省
   */
  provinceId?: string
  /**
   * 单位地区 市
   */
  cityId?: string
  /**
   * 单位地区 区县
   */
  countyId?: string
}

/**
 * 用户查询条件
@author: eleven
@date: 2020/4/19
 */
export class UserParamDTO {
  /**
   * 用户id集合
   */
  userIdList?: Array<string>
}

/**
 * 获取微信opneiId和unionId等信息的入参
Author:FangKunSen
Time:2020-05-18,18:55
 */
export class WXInfoQueryParam {
  code?: string
  /**
   * @see com.fjhb.support.WXConstant
type: 0公众号；1小程序
   */
  type: number
  encryptedData?: string
  iv?: string
}

export class RoleCreateDto {
  id?: string
  name?: string
  description?: string
}

export class RolePermissionDto {
  roleMessage?: RoleCreateDto
  nodeSelectedIdArray?: Array<string>
  itemSelectedIdArray?: Array<string>
  rootSelectedIdArray?: Array<string>
}

export class AdministratorDTO {
  userId: string
  /**
   * 姓名
   */
  name: string
  /**
   * 昵称
   */
  nickName: string
  /**
   * 所属单位id
   */
  unitId: string
  /**
   * 电话
   */
  phoneNumber: string
  /**
   * 邮件
   */
  email: string
  /**
   * 用户级别
   */
  levelValue: number
  /**
   * 状态，1：正常，2：停用
   */
  status: number
  /**
   * 性别:，1：男，2：女，3：中性，4：未知
   */
  sex: number
  /**
   * 头像url
   */
  displayPhotoUrl: string
  remark: string
  /**
   * 创建时间
   */
  createTime: string
  /**
   * 登陆账号集合
   */
  loginAccounts: Array<LoginAccountDTO>
  /**
   * 所拥有的角色集合
   */
  roles: Array<RoleDTO>
}

/**
 * 异步任务日志
@author: eleven
@date: 2020/4/14
 */
export class JobLogDTO {
  /**
   * 异步任务的主键ID
   */
  id: string
  /**
   * 执行状态
   */
  state: UserJobState
  /**
   * 异步任务的名称
   */
  name: string
  /**
   * 异步任务的组名
   */
  group: string
  /**
   * 操作人编号
   */
  operatorId: string
  /**
   * 操作人
比较稳定掉接口，直接返回
   */
  operator: string
  /**
   * 处理总数量
   */
  rowSum: number
  /**
   * 成功数
   */
  rowSuccess: number
  /**
   * 失败数
   */
  rowFail: number
  /**
   * 源文件地址
   */
  originalUrl: string
  /**
   * 处理结果文件
导入：导入成功的数据文件
导出：导出的数据文件
   */
  resultUrl: string
  /**
   * 处理失败的文件地址(导入任务的字段)
   */
  failUrl: string
  /**
   * 开始处理时间
   */
  startDate: string
  /**
   * 处理完成时间
   */
  endDate: string
  /**
   * 导入结果
   */
  result: AsyncExecuteResultEnum
  /**
   * 异常原因
   */
  message: string
}

export class RegionInfoDTO {
  /**
   * 地区路径
   */
  regionPath: string
  /**
   * 省份id
   */
  provinceId: string
  /**
   * 省份名称
   */
  provinceName: string
  /**
   * 城市id
   */
  cityId: string
  /**
   * 城市名称
   */
  cityName: string
  /**
   * 区、县id
   */
  countyId: string
  /**
   * 区、县名称
   */
  countyName: string
}

export class RoleDTO {
  /**
   * 角色ID
   */
  id: string
  /**
   * 角色级别值
   */
  levelValue: number
  /**
   * 角色名称
   */
  name: string
  /**
   * 角色描述
   */
  description: string
  /**
   * 创建方式 | 1:自建; 2:导入
   */
  createType: number
  /**
   * 数据类型 | 1:普通; 2:内置
   */
  dataType: number
  /**
   * 创建人ID
   */
  creatorId: string
  /**
   * 创建时间
   */
  createDate: string
  /**
   * 是否可用
   */
  available: boolean
}

/**
 * 用户绑定的第三方登陆账号信息
@author huanghj
 */
export class UserBindedThirdAccountDTO {
  id: string
  /**
   * 用户ID
   */
  userId: string
  /**
   * 互联方式
@see com.fjhb6.basicdata.userdata.lang.UserMaterialConstant#REGISTER_TYPE_QQ
@see com.fjhb6.basicdata.userdata.lang.UserMaterialConstant#REGISTER_TYPE_SINA_WEIBO
   */
  connectType: number
  /**
   * 用户唯一标识
   */
  openId: string
  /**
   * unionId
   */
  unionId: string
  /**
   * 访问令牌
   */
  accessToken: string
  /**
   * 剩余失效时间, 单位: 秒
   */
  expiresIn: number
  /**
   * 刷新的Token
   */
  refreshToken: string
  /**
   * 用户昵称
   */
  nickname: string
  /**
   * 用户50*50规格头像
   */
  figure_url_50: string
  /**
   * 用户100*100规格头像
   */
  figure_url_100: string
  /**
   * 用户的性别
   */
  gender: string
  /**
   * 所属地区
   */
  location: string
  /**
   * 授权时间
   */
  authorizeTime: string
  /**
   * 是否可用
   */
  available: boolean
}

export class BaseRegionTreeDTO {
  children: Array<BaseRegionTreeDTO>
  id: string
  name: string
  parentId: string
  regionPath: string
  sort: number
  version: string
  available: boolean
}

export class TeachUnitBaseDTO {
  /**
   * 单位id
   */
  unitId: string
  /**
   * 单位名称
   */
  name: string
  /**
   * 组织机构代码
   */
  organizationCode: string
  /**
   * 单位地区
   */
  provinceId: string
  /**
   * 单位地区 市
   */
  cityId: string
  /**
   * 单位地区 区县
   */
  countyId: string
  /**
   * 状态
   */
  status: string
  /**
   * 门户名称
   */
  portalName: string
}

export class TeachUnitInfoDTO {
  /**
   * 是否展示移动
   */
  mobileShow: boolean
  /**
   * 是否展示微信
   */
  wxShow: boolean
  unitId: string
  name: string
  organizationCode: string
  provinceId: string
  cityId: string
  countyId: string
  status: string
  portalName: string
  logoUrl: string
  bannerUrls: Array<string>
  portalFooterDescribe: string
  onlineCustomerInfo: string
  customerPhone: string
  defaultUnitDomain: UnitDomainDTO
}

/**
 * 培训机构分页返回
 */
export class TeachUnitPageDTO {
  id: string
  platformId: string
  platformVersionId: string
  projectId: string
  subProjectId: string
  name: string
  organizationCode: string
  provinceId: string
  cityId: string
  countyId: string
  defaultUnitDomainId: string
  defaultUnitDomain: UnitDomainDTO
  portalName: string
  logoUrl: string
  bannerUrls: Array<string>
  portalFooterDescribe: string
  onlineCustomerInfo: string
  customerPhone: string
  status: string
  teachManager: TeachAdministratorDTO
}

/**
 * 用户详细信息对象
 */
export class UserInfoDTO {
  userId: string
  name: string
  nickName: string
  uniqueType: number
  uniqueData: string
  displayPhotoUrl: string
  sex: number
  bornDay: string
  phoneNumber: string
  postCode: string
  areaPath: string
  address: string
  createDate: string
  registerType: number
  sourceType: number
  registerUnitId: string
  workUnitName: string
  workUnitAreaPath: string
  loginAccounts: Array<LoginAccountDTO>
  highestEducation: string
}

/**
 * 用户精简对象
学员域和管理域公用
@author yeyc create 2020/3/13 9:42
 */
export class UserSimpleInfoDTO {
  /**
   * 用户id
   */
  userId: string
  /**
   * 姓名
   */
  name: string
  /**
   * 昵称
   */
  nickName: string
  /**
   * 唯一性类型
@see UniqueTypeConst
   */
  uniqueType: number
  /**
   * 唯一性值
   */
  uniqueData: string
  /**
   * 头像地址
   */
  displayPhotoUrl: string
  /**
   * 性别
   */
  sex: number
  /**
   * 手机号码
   */
  phoneNumber: string
  /**
   * 所属地区编码
   */
  areaPath: string
}

/**
 * 获取微信必要信息
 */
export class WXIdInfo {
  openId: string
  unionId: string
  accessToken: string
  nickname: string
  refreshToken: string
  sex: string
  headimgurl: string
  purePhoneNumber: string
}

/**
 * @author: eleven
@date: 2020/2/22
@description: 当前登录用户的信息
 */
export class LoginUserDTO {
  /**
   * 用户id
   */
  userId: string
  /**
   * 单位id
   */
  unitId: string
  /**
   * 用户名
   */
  userName: string
  /**
   * 证件号
   */
  identity: string
  /**
   * 头像地址
   */
  photoUrl: string
  /**
   * 当前登录用户所拥有的角色，可同时拥有多种角色
   */
  roleList: Array<UnitTypeEnum>
}

/**
 * 管理员/教师的展示DTO
@author choaklin
@since 0.1.0
 */
export class AdminInfo {
  /**
   * 用户id
   */
  userId: string
  /**
   * 单位ID
   */
  unitId: string
  /**
   * 组织机构ID
   */
  organizationId: string
  /**
   * 管理员所属单位
   */
  unit: string
  /**
   * 管理员所属部门
   */
  organization: string
  /**
   * 管理员姓名, 也是账号的昵称
   */
  name: string
  /**
   * 管理员邮箱
   */
  email: string
  /**
   * 管理员的账号
   */
  loginAccount: string
  /**
   * 头像地址
   */
  displayPhotoUrl: string
  /**
   * 账号的数据类型
@see com.fjhb6.basicdata.userdata.v1.south.api.UserdataSouthConstant#DATA_TYPE_NORMAL
@see com.fjhb6.basicdata.userdata.v1.south.api.UserdataSouthConstant#DATA_TYPE_INTERNAL
   */
  dataType: number
  /**
   * 管理员的管理类型。 1:单位; 2: 部门
   */
  manageType: number
  /**
   * 当前状态
   */
  status: number
}

export class RoleEditDto {
  /**
   * 安全对象组集合
   */
  securityObjectGroupList: Array<SecurityObjectGroupDto>
  /**
   * 第三级安全对象id集合
旧平台的东西，不建议写死层级数，请使用RoleEditDto#securityObjectGroupList
   */
  nodeSelectedIdArray: Array<string>
  /**
   * 第二级安全对象id集合
旧平台的东西，不建议写死层级数，请使用RoleEditDto#securityObjectGroupList
   */
  itemSelectedIdArray: Array<string>
  /**
   * 第一级安全对象id集合
旧平台的东西，不建议写死层级数，请使用RoleEditDto#securityObjectGroupList
   */
  rootSelectedIdArray: Array<string>
}

/**
 * Created by CR on 2018/1/5.
 */
export class RoleInfo {
  /**
   * 平台ID
   */
  platformId: string
  /**
   * 平台版本ID
   */
  platformVersionId: string
  /**
   * 项目ID
   */
  projectId: string
  /**
   * 子项目ID
   */
  subProjectId: string
  /**
   * 单位ID
   */
  unitId: string
  /**
   * 组织机构ID
   */
  organizationId: string
  /**
   * 角色级别值
   */
  levelValue: number
  /**
   * 角色名称
   */
  name: string
  /**
   * 角色的业务对象ID
   */
  objectId: string
  /**
   * 角色描述
   */
  description: string
  /**
   * 创建方式 | 1:自建; 2:导入
   */
  createType: number
  /**
   * 数据类型 | 1:普通; 2:内置
   */
  dataType: string
  /**
   * 创建人名字
   */
  creatorName: string
  /**
   * 创建时间
   */
  createDate: string
  /**
   * 角色ID(new)
   */
  id: string
  /**
   * 是否可用
   */
  available: boolean
  /**
   * 业务对象列表
   */
  aanRolObjectDataList: Array<AanRolObjectData>
}

export class SecurityObjectGroupDto {
  id: string
  name: string
  url: string
  isSelected: boolean
  children: Array<SecurityObjectGroupDto>
  parentId: string
  sort: number
}

/**
 * Created by CR on 2018/6/4.
 */
export class RoleStatistics {
  /**
   * 主键 角色ID
   */
  roleId: string
  /**
   * 角色名称
   */
  name: string
  /**
   * 角色描述
   */
  description: string
  /**
   * 在用的有效的用户数
   */
  userCount: number
  /**
   * 单位名称
   */
  unitName: string
}

export class BaseRegionDTO {
  id: string
  name: string
  parentId: string
  regionPath: string
  sort: number
  version: string
  available: boolean
}

export class LoginAccountDTO {
  loginType: number
  loginInput: string
  password: string
}

export class StudentDTO {
  userId: string
  name: string
  nickName: string
  uniqueType: number
  uniqueData: string
  displayPhotoUrl: string
  sex: number
  bornDay: string
  phoneNumber: string
  postCode: string
  areaPath: string
  address: string
  createDate: string
  registerType: number
  sourceType: number
  registerUnitId: string
  workUnitName: string
  workUnitAreaPath: string
  loginAccounts: Array<LoginAccountDTO>
  highestEducation: string
}

export class TeachAdministratorDTO {
  userId: string
  unitId: string
  name: string
  nickName: string
  uniqueType: number
  uniqueData: string
  status: number
  loginAccounts: Array<LoginAccountDTO>
}

export class UnitDomainDTO {
  id: string
  projectId: string
  subProjectId: string
  unitId: string
  platformId: string
  platformVersionId: string
  domain: string
  domainState: string
}

export class AanRolObjectData {
  id: string
  roleId: string
  objectId: string
  objectType: string
}

export class UserRoleAuthorization {
  userId: string
  nickname: string
  roleId: string
  roleName: string
}

export class AdministratorDTOPage {
  pageSize: number
  pageNo: number
  totalPageSize: number
  totalSize: number
  currentPageData: Array<AdministratorDTO>
}

export class StudentDTOPage {
  pageSize: number
  pageNo: number
  totalPageSize: number
  totalSize: number
  currentPageData: Array<StudentDTO>
}

export class TeachUnitPageDTOPage {
  pageSize: number
  pageNo: number
  totalPageSize: number
  totalSize: number
  currentPageData: Array<TeachUnitPageDTO>
}

export class AdminInfoPage {
  pageSize: number
  pageNo: number
  totalPageSize: number
  totalSize: number
  currentPageData: Array<AdminInfo>
}

export class RoleStatisticsPage {
  pageSize: number
  pageNo: number
  totalPageSize: number
  totalSize: number
  currentPageData: Array<RoleStatistics>
}

export class JobLogDTOPage {
  pageSize: number
  pageNo: number
  totalPageSize: number
  totalSize: number
  currentPageData: Array<JobLogDTO>
}

class DataGateway {
  async _commonQuery<T>(query: DocumentNode, params?: unknown, operation?: string): Promise<Response<T>> {
    return commonRequestApi<T>(SERVER_URL, {
      query: query,
      variables: params,
      operation: operation
    })
  }

  /**   * 统计用户累计登录天数
   * @return
   * @param query 查询 graphql 语法文档
   * @param undefined 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async countUserLoginDay(
    query: DocumentNode = GraphqlImporter.countUserLoginDay,
    operation?: string
  ): Promise<Response<number>> {
    return commonRequestApi<number>(SERVER_URL, {
      query: query,
      variables: undefined,
      operation: operation
    })
  }

  /**   * 用户管理用，导出学员信息excel，返回相对mfs的路径
   * @param query 查询 graphql 语法文档
   * @param queryDTO 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async exportStudentExcelForUserManage(
    queryDTO: UserManageStudentQueryDTO,
    query: DocumentNode = GraphqlImporter.exportStudentExcelForUserManage,
    operation?: string
  ): Promise<Response<string>> {
    return commonRequestApi<string>(SERVER_URL, {
      query: query,
      variables: { queryDTO },
      operation: operation
    })
  }

  /**   * 获取管理员分页信息
   * @param query 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async findAdministratorPage(
    params: { page?: Page; query?: AdministratorQueryDTO },
    query: DocumentNode = GraphqlImporter.findAdministratorPage,
    operation?: string
  ): Promise<Response<AdministratorDTOPage>> {
    return commonRequestApi<AdministratorDTOPage>(SERVER_URL, {
      query: query,
      variables: params,
      operation: operation
    })
  }

  /**   * 根据用户id获取角色安全对象
   * @param userId
   * @param type
   * @return
   * @param query 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async findSecurityGroupByAdministratorId(
    params: { userId?: string; type?: string },
    query: DocumentNode = GraphqlImporter.findSecurityGroupByAdministratorId,
    operation?: string
  ): Promise<Response<Array<SecurityObjectGroupDto>>> {
    return commonRequestApi<Array<SecurityObjectGroupDto>>(SERVER_URL, {
      query: query,
      variables: params,
      operation: operation
    })
  }

  /**   * 客服业务咨询，查询用户信息用，返回的StudentDTO中不会带着loginAccounts
   * @param query 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async findStudentPageForCustomerService(
    params: { page?: Page; query?: CustomerServiceStudentQueryDTO },
    query: DocumentNode = GraphqlImporter.findStudentPageForCustomerService,
    operation?: string
  ): Promise<Response<StudentDTOPage>> {
    return commonRequestApi<StudentDTOPage>(SERVER_URL, {
      query: query,
      variables: params,
      operation: operation
    })
  }

  /**   * 用户管理用的查询学员信息，返回的StudentDTO中不会带着loginAccounts
   * @param query 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async findStudentPageForUserManage(
    params: { page?: Page; query?: UserManageStudentQueryDTO },
    query: DocumentNode = GraphqlImporter.findStudentPageForUserManage,
    operation?: string
  ): Promise<Response<StudentDTOPage>> {
    return commonRequestApi<StudentDTOPage>(SERVER_URL, {
      query: query,
      variables: params,
      operation: operation
    })
  }

  /**   * 获取施教机构单位id（通过域名）
   * 该接口只返回id和name
   * @param domain
   * @return
   * @param query 查询 graphql 语法文档
   * @param domain 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async findTeachUnitByDomain(
    domain: string,
    query: DocumentNode = GraphqlImporter.findTeachUnitByDomain,
    operation?: string
  ): Promise<Response<TeachUnitInfoDTO>> {
    return commonRequestApi<TeachUnitInfoDTO>(SERVER_URL, {
      query: query,
      variables: { domain },
      operation: operation
    })
  }

  /**
   * @param query 查询 graphql 语法文档
   * @param ids 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async findTeachUnitListByIds(
    ids: Array<string>,
    query: DocumentNode = GraphqlImporter.findTeachUnitListByIds,
    operation?: string
  ): Promise<Response<Array<TeachUnitBaseDTO>>> {
    return commonRequestApi<Array<TeachUnitBaseDTO>>(SERVER_URL, {
      query: query,
      variables: { ids },
      operation: operation
    })
  }

  /**   * 获取启用的施教机构分页
   * @param page
   * @return
   * @param query 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async findTeachUnitPage(
    params: { page?: Page; queryParam?: TeachUnitQueryDTO },
    query: DocumentNode = GraphqlImporter.findTeachUnitPage,
    operation?: string
  ): Promise<Response<TeachUnitPageDTOPage>> {
    return commonRequestApi<TeachUnitPageDTOPage>(SERVER_URL, {
      query: query,
      variables: params,
      operation: operation
    })
  }

  /**   * 获取当前管理员所属施教机构
   * @return
   * @param query 查询 graphql 语法文档
   * @param undefined 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async findUnitByAdmin(
    query: DocumentNode = GraphqlImporter.findUnitByAdmin,
    operation?: string
  ): Promise<Response<string>> {
    return commonRequestApi<string>(SERVER_URL, {
      query: query,
      variables: undefined,
      operation: operation
    })
  }

  /**   * 根据角色id获取相关联的管理员
   * @return
   * @param query 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async findUsersByRoleId(
    params: { roleId?: string; page?: Page },
    query: DocumentNode = GraphqlImporter.findUsersByRoleId,
    operation?: string
  ): Promise<Response<AdminInfoPage>> {
    return commonRequestApi<AdminInfoPage>(SERVER_URL, {
      query: query,
      variables: params,
      operation: operation
    })
  }

  /**   * 获取所有组安全对象
   * @return
   * @param query 查询 graphql 语法文档
   * @param undefined 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getAllPermission(
    query: DocumentNode = GraphqlImporter.getAllPermission,
    operation?: string
  ): Promise<Response<Array<SecurityObjectGroupDto>>> {
    return commonRequestApi<Array<SecurityObjectGroupDto>>(SERVER_URL, {
      query: query,
      variables: undefined,
      operation: operation
    })
  }

  /**   * 获取系统的所有角色信息
   * @param query 查询 graphql 语法文档
   * @param undefined 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getAllRoles(
    query: DocumentNode = GraphqlImporter.getAllRoles,
    operation?: string
  ): Promise<Response<Array<RoleDTO>>> {
    return commonRequestApi<Array<RoleDTO>>(SERVER_URL, {
      query: query,
      variables: undefined,
      operation: operation
    })
  }

  /**   * 批量获取用户的第三方绑定账号信息
   * @param query 查询 graphql 语法文档
   * @param userIds 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getBindedThirdAccountsByUserIds(
    userIds: Array<string>,
    query: DocumentNode = GraphqlImporter.getBindedThirdAccountsByUserIds,
    operation?: string
  ): Promise<Response<Array<UserBindedThirdAccountDTO>>> {
    return commonRequestApi<Array<UserBindedThirdAccountDTO>>(SERVER_URL, {
      query: query,
      variables: { userIds },
      operation: operation
    })
  }

  /**   * 获取当前用户绑定的账号信息
   * @param query 查询 graphql 语法文档
   * @param undefined 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getCurrentUserBindedThirdAccounts(
    query: DocumentNode = GraphqlImporter.getCurrentUserBindedThirdAccounts,
    operation?: string
  ): Promise<Response<Array<UserBindedThirdAccountDTO>>> {
    return commonRequestApi<Array<UserBindedThirdAccountDTO>>(SERVER_URL, {
      query: query,
      variables: undefined,
      operation: operation
    })
  }

  /**   * 获取当前用户的用户信息
   * @param query 查询 graphql 语法文档
   * @param undefined 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getCurrentUserInfo(
    query: DocumentNode = GraphqlImporter.getCurrentUserInfo,
    operation?: string
  ): Promise<Response<UserInfoDTO>> {
    return commonRequestApi<UserInfoDTO>(SERVER_URL, {
      query: query,
      variables: undefined,
      operation: operation
    })
  }

  /**   * 统计日访问用户
   * @return
   * @param query 查询 graphql 语法文档
   * @param undefined 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getDailyLoginUserCount(
    query: DocumentNode = GraphqlImporter.getDailyLoginUserCount,
    operation?: string
  ): Promise<Response<number>> {
    return commonRequestApi<number>(SERVER_URL, {
      query: query,
      variables: undefined,
      operation: operation
    })
  }

  /**   * 获取系统中所有可用的角色
   * @param query 查询 graphql 语法文档
   * @param undefined 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getEnabledRoles(
    query: DocumentNode = GraphqlImporter.getEnabledRoles,
    operation?: string
  ): Promise<Response<Array<RoleDTO>>> {
    return commonRequestApi<Array<RoleDTO>>(SERVER_URL, {
      query: query,
      variables: undefined,
      operation: operation
    })
  }

  /**   * 获取登录用户的登录信息
   * @return
   * @param query 查询 graphql 语法文档
   * @param undefined 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getLoginUserInfo(
    query: DocumentNode = GraphqlImporter.getLoginUserInfo,
    operation?: string
  ): Promise<Response<LoginUserDTO>> {
    return commonRequestApi<LoginUserDTO>(SERVER_URL, {
      query: query,
      variables: undefined,
      operation: operation
    })
  }

  /**   * 根据roleId获取安全对象组
   * @return
   * @param query 查询 graphql 语法文档
   * @param roleId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getPermissionByRoleId(
    roleId: string,
    query: DocumentNode = GraphqlImporter.getPermissionByRoleId,
    operation?: string
  ): Promise<Response<Array<SecurityObjectGroupDto>>> {
    return commonRequestApi<Array<SecurityObjectGroupDto>>(SERVER_URL, {
      query: query,
      variables: { roleId },
      operation: operation
    })
  }

  /**   * 获取安全对象--编辑角色
   * @param roleId
   * @return
   * @param query 查询 graphql 语法文档
   * @param roleId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getPermissionForEditRole(
    roleId: string,
    query: DocumentNode = GraphqlImporter.getPermissionForEditRole,
    operation?: string
  ): Promise<Response<RoleEditDto>> {
    return commonRequestApi<RoleEditDto>(SERVER_URL, {
      query: query,
      variables: { roleId },
      operation: operation
    })
  }

  /**   * 根据地区id获取地区信息
   * @param query 查询 graphql 语法文档
   * @param id 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getRegionById(
    id: string,
    query: DocumentNode = GraphqlImporter.getRegionById,
    operation?: string
  ): Promise<Response<BaseRegionDTO>> {
    return commonRequestApi<BaseRegionDTO>(SERVER_URL, {
      query: query,
      variables: { id },
      operation: operation
    })
  }

  /**   * 根据地区路径查询地区信息
   * @param query 查询 graphql 语法文档
   * @param path 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getRegionInfoByPath(
    path: string,
    query: DocumentNode = GraphqlImporter.getRegionInfoByPath,
    operation?: string
  ): Promise<Response<RegionInfoDTO>> {
    return commonRequestApi<RegionInfoDTO>(SERVER_URL, {
      query: query,
      variables: { path },
      operation: operation
    })
  }

  /**   * 根据地区id获取该地区树
   * @param query 查询 graphql 语法文档
   * @param id 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getRegionTree(
    id: string,
    query: DocumentNode = GraphqlImporter.getRegionTree,
    operation?: string
  ): Promise<Response<BaseRegionTreeDTO>> {
    return commonRequestApi<BaseRegionTreeDTO>(SERVER_URL, {
      query: query,
      variables: { id },
      operation: operation
    })
  }

  /**   * 根据地区id集合批量获取地区信息
   * @param query 查询 graphql 语法文档
   * @param ids 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getRegionsByIds(
    ids: Array<string>,
    query: DocumentNode = GraphqlImporter.getRegionsByIds,
    operation?: string
  ): Promise<Response<Array<BaseRegionDTO>>> {
    return commonRequestApi<Array<BaseRegionDTO>>(SERVER_URL, {
      query: query,
      variables: { ids },
      operation: operation
    })
  }

  /**   * 根据id获取角色
   * @return
   * @param query 查询 graphql 语法文档
   * @param roleId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getRoleById(
    roleId: string,
    query: DocumentNode = GraphqlImporter.getRoleById,
    operation?: string
  ): Promise<Response<RoleInfo>> {
    return commonRequestApi<RoleInfo>(SERVER_URL, {
      query: query,
      variables: { roleId },
      operation: operation
    })
  }

  /**   * 根据用户id获取角色
   * @return
   * @param query 查询 graphql 语法文档
   * @param userId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getRoleByUserId(
    userId: string,
    query: DocumentNode = GraphqlImporter.getRoleByUserId,
    operation?: string
  ): Promise<Response<Array<UserRoleAuthorization>>> {
    return commonRequestApi<Array<UserRoleAuthorization>>(SERVER_URL, {
      query: query,
      variables: { userId },
      operation: operation
    })
  }

  /**   * 获取子项目单位id
   * @param param
   * @return
   * @param query 查询 graphql 语法文档
   * @param undefined 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getSubProjectUnit(
    query: DocumentNode = GraphqlImporter.getSubProjectUnit,
    operation?: string
  ): Promise<Response<string>> {
    return commonRequestApi<string>(SERVER_URL, {
      query: query,
      variables: undefined,
      operation: operation
    })
  }

  /**   * 根据父级地区id获取子级地区
   * @param parentId
   * @return
   * @param query 查询 graphql 语法文档
   * @param parentId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getSubRegionListByParentId(
    parentId: string,
    query: DocumentNode = GraphqlImporter.getSubRegionListByParentId,
    operation?: string
  ): Promise<Response<Array<BaseRegionDTO>>> {
    return commonRequestApi<Array<BaseRegionDTO>>(SERVER_URL, {
      query: query,
      variables: { parentId },
      operation: operation
    })
  }

  /**   * 获取施教机构
   * @param unitId
   * @return
   * @param query 查询 graphql 语法文档
   * @param unitId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getTeachUnit(
    unitId: string,
    query: DocumentNode = GraphqlImporter.getTeachUnit,
    operation?: string
  ): Promise<Response<TeachUnitInfoDTO>> {
    return commonRequestApi<TeachUnitInfoDTO>(SERVER_URL, {
      query: query,
      variables: { unitId },
      operation: operation
    })
  }

  /**   * 获取指定用户的第三方绑定账号信息
   * @param query 查询 graphql 语法文档
   * @param userId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getUserBindedThirdAccounts(
    userId: string,
    query: DocumentNode = GraphqlImporter.getUserBindedThirdAccounts,
    operation?: string
  ): Promise<Response<Array<UserBindedThirdAccountDTO>>> {
    return commonRequestApi<Array<UserBindedThirdAccountDTO>>(SERVER_URL, {
      query: query,
      variables: { userId },
      operation: operation
    })
  }

  /**   * 根据微信授权码解析openId和unionId
   * @param param
   * @return
   * @param query 查询 graphql 语法文档
   * @param param 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getWXUserInfo(
    param: WXInfoQueryParam,
    query: DocumentNode = GraphqlImporter.getWXUserInfo,
    operation?: string
  ): Promise<Response<WXIdInfo>> {
    return commonRequestApi<WXIdInfo>(SERVER_URL, {
      query: query,
      variables: { param },
      operation: operation
    })
  }

  /**   * 判断用户是否登录
   * @return
   * @param query 查询 graphql 语法文档
   * @param undefined 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async isLogin(query: DocumentNode = GraphqlImporter.isLogin, operation?: string): Promise<Response<boolean>> {
    return commonRequestApi<boolean>(SERVER_URL, {
      query: query,
      variables: undefined,
      operation: operation
    })
  }

  /**   * 判断账号是否存在
   * @param check 0：忽略该字段|1：false
   * @param field
   * @return 存在则返回false
   * @param query 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async isRoleExist(
    params: { check: number; field?: string },
    query: DocumentNode = GraphqlImporter.isRoleExist,
    operation?: string
  ): Promise<Response<boolean>> {
    return commonRequestApi<boolean>(SERVER_URL, {
      query: query,
      variables: params,
      operation: operation
    })
  }

  /**   * 查询用户信息
   * @param param
   * @return
   * @param query 查询 graphql 语法文档
   * @param param 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async listUserInfo(
    param: UserParamDTO,
    query: DocumentNode = GraphqlImporter.listUserInfo,
    operation?: string
  ): Promise<Response<Array<UserSimpleInfoDTO>>> {
    return commonRequestApi<Array<UserSimpleInfoDTO>>(SERVER_URL, {
      query: query,
      variables: { param },
      operation: operation
    })
  }

  /**   * 获取角色分页
   * @param page
   * @return
   * @param query 查询 graphql 语法文档
   * @param page 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async pageRolesByQuery(
    page: Page,
    query: DocumentNode = GraphqlImporter.pageRolesByQuery,
    operation?: string
  ): Promise<Response<RoleStatisticsPage>> {
    return commonRequestApi<RoleStatisticsPage>(SERVER_URL, {
      query: query,
      variables: { page },
      operation: operation
    })
  }

  /**   * 异步任务处理结果查询
   * @param page
   * @param param
   * @return
   * @param query 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async pageUserJob(
    params: { page?: Page; param?: UserJobParamDTO },
    query: DocumentNode = GraphqlImporter.pageUserJob,
    operation?: string
  ): Promise<Response<JobLogDTOPage>> {
    return commonRequestApi<JobLogDTOPage>(SERVER_URL, {
      query: query,
      variables: params,
      operation: operation
    })
  }

  /**   * 删除角色
   * @param
   * @return
   * @param mutate 查询 graphql 语法文档
   * @param roleId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async deleteRole(
    roleId: string,
    mutate: DocumentNode = GraphqlImporter.deleteRole,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: { roleId },
      operation: operation
    })
  }

  /**
   * @param mutate 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getPermission(
    params: {
      nodeSelectedIdArray?: Array<string>
      itemSelectedIdArray?: Array<string>
      rootSelectedIdArray?: Array<string>
    },
    mutate: DocumentNode = GraphqlImporter.getPermission,
    operation?: string
  ): Promise<Response<Array<string>>> {
    return commonRequestApi<Array<string>>(SERVER_URL, {
      query: mutate,
      variables: params,
      operation: operation
    })
  }

  /**   * 保存角色
   * @param
   * @return
   * @param mutate 查询 graphql 语法文档
   * @param roleDto 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async saveRole(
    roleDto: RolePermissionDto,
    mutate: DocumentNode = GraphqlImporter.saveRole,
    operation?: string
  ): Promise<Response<boolean>> {
    return commonRequestApi<boolean>(SERVER_URL, {
      query: mutate,
      variables: { roleDto },
      operation: operation
    })
  }
}

export default new DataGateway()
